import { __extends } from "tslib";
import { GestureEvent } from './GestureEvent';
var TransformGestureEvent = /** @class */ (function (_super) {
    __extends(TransformGestureEvent, _super);
    function TransformGestureEvent(type, bubbles, cancelable, phase, localX, localY, scaleX, scaleY, rotation, offsetX, offsetY, ctrlKey, altKey, shiftKey) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (phase === void 0) { phase = null; }
        if (localX === void 0) { localX = 0; }
        if (localY === void 0) { localY = 0; }
        if (scaleX === void 0) { scaleX = 1; }
        if (scaleY === void 0) { scaleY = 1; }
        if (rotation === void 0) { rotation = 0; }
        if (offsetX === void 0) { offsetX = 0; }
        if (offsetY === void 0) { offsetY = 0; }
        if (ctrlKey === void 0) { ctrlKey = false; }
        if (altKey === void 0) { altKey = false; }
        if (shiftKey === void 0) { shiftKey = false; }
        return _super.call(this, type, bubbles, cancelable, phase, localX, localY, ctrlKey, altKey, shiftKey) || this;
    }
    TransformGestureEvent.classInitializer = null;
    TransformGestureEvent.classSymbols = null;
    TransformGestureEvent.instanceSymbols = null;
    // JS -> AS Bindings
    TransformGestureEvent.GESTURE_ZOOM = 'gestureZoom';
    TransformGestureEvent.GESTURE_PAN = 'gesturePan';
    TransformGestureEvent.GESTURE_ROTATE = 'gestureRotate';
    TransformGestureEvent.GESTURE_SWIPE = 'gestureSwipe';
    return TransformGestureEvent;
}(GestureEvent));
export { TransformGestureEvent };
